import { Routes } from '@angular/router';
import { LayoutComponent } from './dashboard/layout/layout.component';
import { EntityListComponent } from './dashboard/entity/entity-list.component';
import { OotbEntityListComponent } from './dashboard/entity/ootb-entity-list.component';
import { authGuard } from './services/auth.guard';
import { ClientListComponent } from './dashboard/client/client-list/client-list.component';
import { PagesComponent } from './dashboard/pages/pages.component';
import { PageDataComponent } from './dashboard/pages/page-data/page-data.component';
import { BlocklyInterfaceComponent } from './dashboard/ui-editor/blockly-interface/blockly-interface.component';
import { UserMgmtComponent } from './dashboard/user-mgmt/user-mgmt.component';
import { UsersWorkspacesComponent } from './dashboard/users-workspaces/users-workspaces.component';
import { QueryComponent } from './dashboard/query/query.component';
import { SchemaExplorerComponent } from './dashboard/query/schema-explorer.component';
import { ModuleListComponent } from './dashboard/modules/module-list.component';
import { ChartStyleComponent } from './dashboard/chart-style/chart-style.component';
import { TeamOnlyComponent } from './auth/team-only/team-only.component';
import { RUNTIME_ROUTES } from './runtime.routes';

/**
 * THE EDITOR BUILD'S ROUTES: the builder screens below, plus every route a Live app has
 * (RUNTIME_ROUTES — login, landing, ui-editor, …). The Live build replaces this whole file with
 * app.routes.runtime.ts, so nothing imported here reaches a published app. A route a Live app needs
 * goes in runtime.routes.ts, not here.
 */
export const routes: Routes = [
  {
    path: 'dashboard',
    canActivate: [authGuard],
    component: LayoutComponent,
    children: [
      {
        path: 'entity-list',
        component: EntityListComponent,
      },
      {
        path: 'ootb-entity',
        component: OotbEntityListComponent,
      },
      { path: 'client-list', component: ClientListComponent },
      { path: 'pages', component: PagesComponent },
      { path: 'user-mgmt', component: UserMgmtComponent },
      { path: 'users-workspaces', component: UsersWorkspacesComponent },
      { path: 'modules', component: ModuleListComponent },
      { path: 'pageData', component: PageDataComponent },
      { path: 'function-editor', component: BlocklyInterfaceComponent },
      // The app's first lazy routes (spec, Where the code lives): nothing Bastion ships, CodeMirror
      // included, reaches users of a published app.
      {
        path: 'bastion',
        loadComponent: () => import('./dashboard/bastion/list/bastion-list.component')
          .then((m) => m.BastionListComponent),
      },
      // The builder's runner, and the Worker it makes, are provided on this lazy child route, so they stay out of main.
      {
        path: 'bastion/:flowId',
        loadChildren: () => import('./dashboard/bastion/builder/bastion-builder.component')
          .then((m) => m.BUILDER_ROUTES),
      },
    ],
  },
  // ─── STANDALONE, OUTSIDE THE DASHBOARD LAYOUT ───────────────────────────────────────────────────
  // ⚠ NOT a child of `dashboard`, and that is the whole point. Those children render inside
  // LayoutComponent, which brings the project sidebar with it — and this page is BUILDER-level, not
  // project-level: it edits `builderPrefs/{uid}`, requires no client, and performs no selection. A
  // nav offering Data / Pages / Users beside it would be offering things that do not exist here.
  // Same shape as `ui-editor` (runtime.routes.ts) and `query` below.
  { path: 'chart-style', canActivate: [authGuard], component: ChartStyleComponent },
  { path: 'query', canActivate: [authGuard], component: QueryComponent },
  { path: 'schema-explorer', canActivate: [authGuard], component: SchemaExplorerComponent },
  // Dev editor refusal (release Plan 2). UNGUARDED — the account has just been signed out.
  { path: 'team-only', component: TeamOnlyComponent },
  ...RUNTIME_ROUTES,
];
